import { RootState } from "@app/redux/root-reducer";

export const selectModelState = (store: RootState) => store.modelReducer.model;

export const selectAddModelState = (store: RootState) =>
  store.modelReducer.addModel;

export const selectUpdateModelState = (store: RootState) =>
  store.modelReducer.updateModel;

export const selectDeleteModelState = (store: RootState) =>
  store.modelReducer.deleteModel;
